export const partnerEditorTranslation = {
  container: {
    button: {
      apply: 'partnereditor-container-button-apply',
      cancel: 'partnereditor-container-button-cancel',
      close: 'partnereditor-container-button-close',
      edit: 'partnereditor-container-button-edit',
      inactivate: 'partnereditor-container-button-inactivate',
      audit: 'partnereditor-container-button-audit',
    },
    tips: {
      inactivate: {
        possible: 'partnereditor-container-tips-inactivate-possible',
        notPossible: 'partnereditor-container-tips-inactivate-not-possible',
      },
      workflowStatusReadOnly: 'partnereditor-container-tips-workflow-status-read-only',
    },
  },
  header: {
    partnerSummury: {
      partnerId: 'partnereditor-header-partnersummury-partnerid',
      locationId: 'partnereditor-header-partnersummury-locationid',
    },
    partnerFormTitle: {
      formType: 'partnereditor-header-partnerformtitle-formtype',
    },
  },
  workflowStatus: {
    label: 'partnereditor-workflowstatus-label',
    button: {
      approve: 'partnereditor-workflowstatus-button-approve',
      remove: 'partnereditor-workflowstatus-button-remove',
      reject: 'partnereditor-workflowstatus-button-reject',
    },
  },
  dialog: {
    closeConfirm: {
      title: 'partnereditor-dialog-closeconfirm-title',
      content: 'partnereditor-dialog-closeconfirm-content',
      confirmBtn: 'partnereditor-dialog-closeconfirm-confirm-btn',
      rejectBtn: 'partnereditor-dialog-closeconfirm-reject-btn',
    },
    approveRequest: {
      title: 'partnereditor-dialog-approverequest-title',
      content: 'partnereditor-dialog-approverequest-content',
      confirmBtn: 'partnereditor-dialog-approverequest-confirm-btn',
      rejectBtn: 'partnereditor-dialog-approverequest-reject-btn',
    },
    rejectRequest: {
      title: 'partnereditor-dialog-rejectrequest-title',
      content: 'partnereditor-dialog-rejectrequest-content',
      confirmBtn: 'partnereditor-dialog-rejectrequest-confirm-btn',
      rejectBtn: 'partnereditor-dialog-rejectrequest-reject-btn',
    },
    removeRequest: {
      title: 'partnereditor-dialog-removerequest-title',
      content: 'partnereditor-dialog-removerequest-content',
      confirmBtn: 'partnereditor-dialog-removerequest-confirm-btn',
      rejectBtn: 'partnereditor-dialog-removerequest-reject-btn',
    },
    mandatoryAttachments: {
      title: 'partnereditor-dialog-mandatoryattachments-title',
      confirmBtn: 'partnereditor-dialog-mandatoryattachments-confirm-btn',
      rejectBtn: 'partnereditor-dialog-mandatoryattachments-reject-btn',
    },
    inactivatePartner: {
      title: 'partnereditor-dialog-inactivatepartner-title',
      content: 'partnereditor-dialog-removerequest-content',
      confirmBtn: 'partnereditor-dialog-inactivatepartner-confirm-btn',
      rejectBtn: 'partnereditor-dialog-inactivatepartner-reject-btn',
    },
    rejectInactivationPartner: {
      title: 'partnereditor-dialog-rejectinactivationpartner-title',
      content: 'partnereditor-dialog-rejectinactivationpartner-content',
      confirmBtn: 'partnereditor-dialog-rejectinactivationpartner-confirm-btn',
      rejectBtn: 'partnereditor-dialog-rejectinactivationpartner-reject-btn',
    },
  },
  validation: {
    attachments: 'partnereditor-validation-attachments',
  },
  other: {
    menuStatus: 'partnereditor-other-menu-status',
    menuInactive: 'partnereditor-other-menu-inactive',
    hasMandatoryAttachments: 'partnereditor-other-has-mandatory-attachments',
    mandatoryAttachmentsHelp: 'partnereditor-other-mandatory-attachments-help',
  },
  inactivePartnerPanel: {
    content: 'partnereditor-inactivepartnerpanel-content',
    button: 'partnereditor-inactivepartnerpanel-button',
  },
  warning: {
    changesNeedToBeApproved: 'partnereditor-warning-changes_need_to_be_approved',
    successfulUpdate: 'partnereditor-warning-successful_update',
    requestCreated: 'partnereditor-warning-request_created',
    readOnlyPartnerFlags: 'partnereditor-warning-read_only_partner_flags',
  },
}
